<template>
  <div class="container">
    <div class="row">
      <div class="col-12" style="padding: 0; margin: 0 -6px">
        <ul class="nav nav-pills nav-fill" role="tablist">
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-left: -15px"
          >
            <a
                class="nav-link cursor-pointer"
                :class="{ active: tab === 1 }"
                id="yours_task-tab"
                aria-controls="yours_task"
                aria-selected="true"
                @click="setTab(1)"
            >
              Yours
            </a>
          </li>
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-right: -27px"
          >
            <a
                class="nav-link cursor-pointer"
                :class="{ active: tab === 2 }"
                id="pending_task-tab"
                aria-controls="pending_task"
                aria-selected="true"
                @click="setTab(2)"
            >
              Pending
            </a>
          </li>
          <li
              class="nav-item nav-border-override"
              role="presentation"
              style="margin-right: -27px"
          >
            <a
                class="nav-link cursor-pointer"
                :class="{ active: tab === 3 }"
                id="completed_task-tab"
                aria-controls="completed_task"
                aria-selected="true"
                @click="setTab(3)"
            >
              Completed
            </a>
          </li>
        </ul>
      </div>

      <div class="col-12 mt-4">
        <div class="row">
          <div class="col">
            <div class="new-task-label">
              <InfoIcon/>
              All Tasks
            </div>
          </div>
          <div class="col text-right">
            <div class="btn-group">
              <a href="/tasks/advanced?type=todo" class="btn wfh-btn-primary-outline mr-2">
                <i class="fas fa-plus mr-2"></i> New Task
              </a>
              <button type="button" class="btn wfh-btn-primary-outline dropdown-toggle dropdown-toggle-split"
                      style="padding: 0 !important;min-width: 35px;" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                <img src="/images/caret-down.svg" alt="dropdown">
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="/tasks/advanced?type=todo">Create New Task</a>
                <a class="dropdown-item" href="/tasks/open">Get New Task</a>
              </div>
            </div>
          </div>
        </div>

        <YourTasks v-if="isYourTaskTab"/>
        <PendingTasks v-if="isPendingTaskTab"/>
        <CompletedTasks v-if="isCompletedTaskTab"/>
      </div>
    </div>
  </div>
</template>

<script>
import InfoIcon from '../../Misc/InfoIcon';
import PendingTasks from './List/PendingTasks';
import YourTasks from './List/YourTasks';
import CompletedTasks from './List/CompletedTasks';

export default {
  components: { CompletedTasks, PendingTasks, InfoIcon, YourTasks },

  data () {
    return {
      tab: 1,
      tabMap: {
        pending: 2,
        completed: 3,
      },
    };
  },

  computed: {
    isYourTaskTab () {
      return this.tab === 1;
    },

    isPendingTaskTab () {
      return this.tab === 2;
    },

    isCompletedTaskTab () {
      return this.tab === 3;
    },
  },

  methods: {
    setTab (tab) {
      const page = _.invert(this.tabMap)[tab];

      if (page) {
        location.hash = page;
      } else {
        history.pushState('', document.title, window.location.pathname + window.location.search);
      }

      this.tab = tab;
    },
  },

  mounted () {
    const tab = window.location.hash.substr(1);

    this.tab = this.tabMap[tab] ?? 1;
  },
};
</script>

<style scoped lang="scss">
.page-title {
  color: #303030;
  font-family: Lato, serif;
  font-size: 38px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 53.2px;
}

.page-description {
  color: #606064;
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 28px;
}

.new-task-label {
  display: flex;
  align-items: center;
  color: #303030;
  font-family: Lato, serif;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
}

.link-btn {
  display: flex;
  align-items: center;
  color: #303030;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  border: none;
  outline: none;
  background-color: transparent;

  .fas {
    color: #3593fe !important;
  }
}

.empty-state-title {
  color: #333;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
}

.empty-state-description {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  padding: 12px 0;
}
</style>
